publishingApp.directive('dropzone', function ($timeout) {
    return function (scope, element, attrs) {
        var config, dropzone;

        config = scope[attrs.dropzone];

        // create a Dropzone for the element with the given options
        dropzone = new Dropzone(element[0], config.options);

        // bind the given event handlers
        angular.forEach(config.eventHandlers, function (handler, event) {
            dropzone.on(event, handler);
        });
    };
});

/*addedfile: function(file) {
 var temp = file.previewTemplate;
 var FR= new FileReader();
 FR.onload = function(e) {
 element.find('.my-preview').attr('src',e.target.result);
 };
 FR.readAsDataURL( file );
 }*/